import NewBadge from 'components/ReusableComponents/NewBadge'
import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'

import { ReactComponent as ChevronIcon } from '../CampaignControls/chevron.svg'
import styles from './AdvancedInviteSettings.module.scss'

const CollapsibleSettingsPanel = ({
  title,
  showNewBadge = false,
  isExpanded,
  onToggle,
  children
}) => {
  return (
    <div className={styles.card}>
      <div
        className={[styles.header, isExpanded && styles.headerExpanded].filter(Boolean).join(' ')}
      >
        <div className={styles.headerMain}>
          <span className={styles.headerLabelRow}>
            <span className={styles.headerLabel}>{title}</span>
            {showNewBadge && <NewBadge className={styles.newBadge}>BETA</NewBadge>}
          </span>
        </div>
        <PrimarySmallButton
          type="button"
          className={styles.modifyToggle}
          aria-expanded={isExpanded}
          onClick={onToggle}
        >
          Modify
          <ChevronIcon
            className={[styles.chevron, isExpanded && styles.chevronOpen].filter(Boolean).join(' ')}
            aria-hidden="true"
          />
        </PrimarySmallButton>
      </div>
      {isExpanded && <div className={styles.panelBody}>{children}</div>}
    </div>
  )
}

export default CollapsibleSettingsPanel
